
import { supabase } from '@/integrations/supabase/client';
import { ClienteSubdivisaoRegra } from '@/types/clienteSubdivisao';

export const buscarRegrasSubdivisao = async (clientePaiId: number): Promise<ClienteSubdivisaoRegra[]> => {
  try {
    const { data, error } = await supabase
      .from('cliente_subdivisao_regras')
      .select('*')
      .eq('cliente_pai_id', clientePaiId)
      .eq('ativo', true)
      .order('prioridade', { ascending: true });

    if (error) {
      console.error('Erro ao buscar regras de subdivisão:', error);
      return [];
    }

    return (data || []).map((item: any) => ({
      ...item,
      operador_ids: item.operador_ids ? (Array.isArray(item.operador_ids) ? item.operador_ids : []) : null,
    })) as ClienteSubdivisaoRegra[];
  } catch (error) {
    console.error('Erro inesperado ao buscar regras de subdivisão:', error);
    return [];
  }
};
